module.exports = __webpack_public_path__ + "static/14-204f19960363fa90ae47b54fd0387715.png";